import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner, toast } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { isPontoStandalone } from "@/lib/appMode";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { TopBar } from "@/components/TopBar";
import { AuthProvider } from "@/hooks/useAuth";
import { PermissoesProvider } from "@/contexts/PermissoesContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { FORMULARIOS } from "@/domain/formularios";
import SemPermissao from "./pages/SemPermissao";
import ConfiguracaoPerfil from "./pages/cadastros/Usuarios/ConfiguracaoPerfil";
import Index from "./pages/Index";
import Estoque from "./pages/Estoque/Estoque";
import Persons from "./pages/cadastros/Pessoas/Persons";
import PersonFormPage from "./pages/cadastros/Pessoas/PersonForm";
import CustomerGroups from "./pages/cadastros/Pessoas/CustomerGroups";
import NotasFiscais from "./pages/Fiscal/NotasFiscais";
import NotaFiscalDetalhe from "./pages/Fiscal/NotaFiscalDetalhe";
import NovaNotaFiscal from "./pages/Fiscal/NovaNotaFiscal";
import NotasServico from "./pages/Fiscal/NotasServico";
import EmissaoNfse from "./pages/Fiscal/EmissaoNfse";
import EmissaoNfce from "./pages/Fiscal/EmissaoNfce";
import DetalheNfse from "./pages/Fiscal/DetalheNfse";
import Sped from "./pages/Sped";
import Apuracoes from "./pages/Contabil/Apuracoes";
import ApuracaoDetalhe from "./pages/Contabil/ApuracaoDetalhe";
import Razao from "./pages/Contabil/Razao";
import LancamentoForm from "./pages/Contabil/LancamentoForm";
import ParametrizacaoContabil from "./pages/Contabil/ParametrizacaoContabil";
import ConfigPonto from "./pages/RH/Ponto/ConfigPonto";
import EspelhoPonto from "./pages/RH/Ponto/EspelhoPonto";
import Batida from "./pages/RH/Ponto/Batida";
import Feriados from "./pages/RH/Ponto/Feriados";
import Jornadas from "./pages/RH/Ponto/Jornadas";
import Funcionarios from "./pages/RH/Ponto/Funcionarios";
import Exportacoes from "./pages/RH/Ponto/Exportacoes";
import Comprovantes from "./pages/RH/Ponto/Comprovantes";
import PainelPonto from "./pages/RH/Ponto/Painel";
import AjustesPonto from "./pages/RH/Ponto/Ajustes";
import MeuPonto from "./pages/RH/Ponto/MeuPonto";
import Dispositivos from "./pages/RH/Ponto/Dispositivos";
import ConsentimentoLgpd from "./pages/RH/Ponto/ConsentimentoLgpd";
import RelatoriosContabeis from "./pages/Contabil/RelatoriosContabeis";
import PlataformaContador from "./pages/Contabil/PlataformaContador";
import CentralFiscal from "./pages/Contabil/CentralFiscal";
import Impostos from "./pages/Fiscal/Impostos";
import ContasPagar from "./pages/Financeiros/ContasPagar";
import ContasPagarGerencial from "./pages/Financeiros/ContasPagarGerencial";
import ContasReceber from "./pages/Financeiros/ContasReceber";
import ContasReceberGerencial from "./pages/Financeiros/ContasReceberGerencial";
import Faturas from "./pages/Financeiros/Faturas";
import Renegociacoes from "./pages/Financeiros/Renegociacoes";
import FluxoCaixa from "./pages/Financeiros/FluxoCaixa";
import FluxoCaixaGerencial from "./pages/Financeiros/FluxoCaixaGerencial";
import ControleCaixas from "./pages/Financeiros/ControleCaixas";
import RelatoriosFinanceiros from "./pages/Financeiros/RelatoriosFinanceiros";
import ConciliacaoBancaria from "./pages/Financeiros/ConciliacaoBancaria";
import GerenciamentoCartao from "./pages/Financeiros/GerenciamentoCartao";
import PagamentoLote from "./pages/Financeiros/PagamentoLote";
import AtivosFixos from "./pages/Financeiros/AtivosFixos";
import ConciliacaoOfx from "./pages/Financeiros/ConciliacaoOfx";
import IntegracaoBancaria from "./pages/Financeiros/IntegracaoBancaria";
import GestaoBoletos from "./pages/Financeiros/GestaoBoletos";
import Transferencias from "./pages/Financeiros/Transferencias";
import DashboardExecutivo from "./pages/Dashboards/DashboardExecutivo";
import Rotas from "./pages/cadastros/Rotas/Rotas";
import RotaMontagem from "./pages/cadastros/Rotas/RotaMontagem";
import PriceTables from "./pages/cadastros/Produto/PriceTables";
import Produtos from "./pages/cadastros/Produto/Produtos";
import ProdutoFormPage from "./pages/cadastros/Produto/ProdutoForm";
import GradeXPage from "./pages/cadastros/Produto/GradeX";
import GradeYPage from "./pages/cadastros/Produto/GradeY";
import OpcionaisPage from "./pages/cadastros/Produto/Opcionais";
import Countries from "./pages/cadastros/Localizacao/Countries";
import States from "./pages/cadastros/Localizacao/States";
import Cities from "./pages/cadastros/Localizacao/Cities";
import ProductGroups from "./pages/cadastros/Produto/ProductGroups";
import ProductSubgroups from "./pages/cadastros/Produto/ProductSubgroups";
import ProductSections from "./pages/cadastros/Produto/ProductSections";
import ProductSubsections from "./pages/cadastros/Produto/ProductSubsections";
import ProductBrands from "./pages/cadastros/Produto/ProductBrands";
import ProductModels from "./pages/cadastros/Produto/ProductModels";
import GarantiasCadastro from "./pages/cadastros/Produto/Garantias";
import UnidadesProduto from "./pages/cadastros/Produto/UnidadesProduto";
import Bancos from "./pages/cadastros/Financeiro/Bancos";
import ContasCorrentes from "./pages/cadastros/Financeiro/ContasCorrentes";
import Cartoes from "./pages/cadastros/Financeiro/Cartoes";
import FormasPagamento from "./pages/cadastros/Financeiro/FormasPagamento";
import OperacoesFluxoCaixa from "./pages/cadastros/Financeiro/OperacoesFluxoCaixa";
import CondicoesPagamento from "./pages/cadastros/Financeiro/CondicoesPagamento";
import CentrosCusto from "./pages/cadastros/Contabil/CentrosCusto";
import GruposDespesaReceita from "./pages/cadastros/Contabil/GruposDespesaReceita";
import ContasDespesaReceita from "./pages/cadastros/Contabil/ContasDespesaReceita";
import PlanoDeContas from "./pages/cadastros/Contabil/PlanoDeContas";
import PlanoDeContasGerencial from "./pages/cadastros/Contabil/PlanoDeContasGerencial";
import ConfiguracaoEmpresa from "./pages/Configuracoes/Empresa";
import ApiKeys from "./pages/Configuracoes/ApiKeys";
import ImportacaoDados from "./pages/Configuracoes/ImportacaoDados";
import ConfiguracoesFiscais from "./pages/Configuracoes/ConfiguracoesFiscais";
import ConfiguracaoNfse from "./pages/Configuracoes/ConfiguracaoNfse";
import ConfiguracoesWhatsApp from "./pages/Configuracoes/ConfiguracoesWhatsApp";
import ConfiguracoesWhatsAppCloud from "./pages/Configuracoes/ConfiguracoesWhatsAppCloud";
import WhatsAppTemplates from "./pages/Configuracoes/WhatsAppTemplates";
import ParametrosSistema from "./pages/Configuracoes/ParametrosSistema";
import DashboardPerfis from "./pages/Configuracoes/DashboardPerfis";
import LocalEstoque from "./pages/cadastros/Estoque/LocalEstoque";
import Veiculos from "./pages/cadastros/Estoque/Veiculos";
import CfopPage from "./pages/cadastros/Fiscal/Cfop";
import CstIcmsPage from "./pages/cadastros/Fiscal/CstIcms";
import FcpPartilhaPage from "./pages/cadastros/Fiscal/FcpPartilha";
import AnpCombustivelPage from "./pages/cadastros/Fiscal/AnpCombustivel";
import MonofasicosAnpPage from "./pages/cadastros/Fiscal/MonofasicosAnp";
import NcmPageComp from "./pages/cadastros/Fiscal/NcmPage";
import NaturezaOperacaoPage from "./pages/cadastros/Fiscal/NaturezaOperacao";
import ClassificacaoFiscalPage from "./pages/cadastros/Fiscal/ClassificacaoFiscal";
import CorrelacaoCfopCstPage from "./pages/cadastros/Fiscal/CorrelacaoCfopCst";
import CClassTribPage from "./pages/cadastros/Fiscal/CClassTrib";
import BeneficioFiscalPage from "./pages/cadastros/Fiscal/BeneficioFiscal";
import CestPage from "./pages/cadastros/Fiscal/Cest";
import MonofasicoPage from "./pages/cadastros/Fiscal/Monofasico";
import TributosUfDestinoPage from "./pages/cadastros/Fiscal/TributosUfDestino";
import RegraFiscalPage from "./pages/cadastros/Fiscal/RegraFiscal";
import Usuarios from "./pages/cadastros/Usuarios/Usuarios";
import Perfis from "./pages/cadastros/Usuarios/Perfis";
import Auth from "./pages/Auth";
import DefinirSenha from "./pages/DefinirSenha";
import ResetPassword from "./pages/cadastros/Usuarios/ResetPassword";
import NotFound from "./pages/NotFound";
import FrenteCaixa from "./pages/Pdv/FrenteCaixa";
import HistoricoEstornos from "./pages/Pdv/HistoricoEstornos";
import ConciliacaoCaixa from "./pages/Pdv/ConciliacaoCaixa";
import SincronizacaoOffline from "./pages/Pdv/SincronizacaoOffline";
import Dav from "./pages/Operacional/Dav";
import DavForm from "./pages/Operacional/DavForm";
import DavImpressaoTermica from "./pages/Operacional/DavImpressaoTermica";
import Orcamentos from "./pages/Operacional/Orcamentos";
import OrcamentoForm from "./pages/Operacional/OrcamentoForm";
import Entregas from "./pages/Operacional/Entregas";
import OrdemServico from "./pages/Operacional/OrdemServico";
import OrdemServicoForm from "./pages/Operacional/OrdemServicoForm";
import StatusOs from "./pages/Operacional/StatusOs";
import Condicional from "./pages/Operacional/Condicional";
import CondicionalForm from "./pages/Operacional/CondicionalForm";
import Crm from "./pages/Operacional/Crm";
import CrmDetalhe from "./pages/Operacional/CrmDetalhe";
import CrmPipeline from "./pages/Operacional/CrmPipeline";
import CrmDashboardPage from "./pages/Operacional/CrmDashboard";
import CrmRelatoriosPage from "./pages/Operacional/CrmRelatorios";
import Visao360 from "./pages/Operacional/Visao360";
import Atividades from "./pages/Operacional/Atividades";
import Campanhas from "./pages/Operacional/Campanhas";
import Waves from "./pages/Operacional/Waves";
import WaveDetalhe from "./pages/Operacional/WaveDetalhe";
import Cargas from "./pages/Operacional/Cargas";
import CargaForm from "./pages/Operacional/CargaForm";
import Projetos from "./pages/Operacional/Projetos";
import ProjetoForm from "./pages/Operacional/ProjetoForm";
import ApontamentoHoras from "./pages/Operacional/ApontamentoHoras";
import AprovacaoTimesheet from "./pages/Operacional/AprovacaoTimesheet";
import PcpOrdens from "./pages/Operacional/PcpOrdens";
import PcpOrdemForm from "./pages/Operacional/PcpOrdemForm";
import FichasTecnicas from "./pages/Operacional/FichasTecnicas";
import EtapasProducao from "./pages/Operacional/EtapasProducao";
import PlanejamentoMrp from "./pages/Operacional/PlanejamentoMrp";
import LiberacaoDesconto from "./pages/Operacional/LiberacaoDesconto";
import Requisicao from "./pages/Operacional/Requisicao";
import RequisicaoForm from "./pages/Operacional/RequisicaoForm";
import Caixa from "./pages/Financeiros/Caixa";
import PosicaoEstoque from "./pages/Estoque/PosicaoEstoque";
import MovimentacaoEstoque from "./pages/Estoque/MovimentacaoEstoque";
import MovimentacaoForm from "./pages/Estoque/MovimentacaoForm";
import InventarioEstoque from "./pages/Estoque/InventarioEstoque";
import InventarioForm from "./pages/Estoque/InventarioForm";
import NecessidadeReposicao from "./pages/Estoque/NecessidadeReposicao";
import RelatoriosEstoque from "./pages/Estoque/RelatoriosEstoque";
import GestaoLotes from "./pages/Estoque/GestaoLotes";
import HistoricoMovProduto from "./pages/Estoque/HistoricoMovProduto";
import MovimentacaoDetalhe from "./pages/Estoque/MovimentacaoDetalhe";
import Etiquetas from "./pages/Estoque/Etiquetas";
import TransferenciasEstoque from "./pages/Estoque/Transferencias";
import VeiculosEstoque from "./pages/Estoque/VeiculosEstoque";
import VeiculoEstoqueDetalhe from "./pages/Estoque/VeiculoEstoqueDetalhe";
import PendenciasRenave from "./pages/Estoque/PendenciasRenave";
import ConfiguracaoRenave from "./pages/Configuracoes/ConfiguracaoRenave";
import RegrasAprovacaoTransferencia from "./pages/Estoque/RegrasAprovacaoTransferencia";
import CiclosContagem from "./pages/Estoque/CiclosContagem";
import ContagensCiclo from "./pages/Estoque/ContagensCiclo";
import AjustesEstoque from "./pages/Estoque/AjustesEstoque";
import MentorIA from "./pages/MentorIA/MentorIA";
import MentorOperacional from "./pages/MentorOperacional/MentorOperacional";
import Garantias from "./pages/Operacional/Garantias/Garantias";
import GarantiaForm from "./pages/Operacional/Garantias/GarantiaForm";
import ReceitasSngpc from "./pages/Operacional/ReceitasSngpc";
import TransmissoesSngpc from "./pages/Operacional/TransmissoesSngpc";
import Fornecedores from "./pages/Compras/Fornecedores";
import FornecedorForm from "./pages/Compras/FornecedorForm";
import RequisicaoCompra from "./pages/Compras/RequisicaoCompra";
import RequisicaoCompraForm from "./pages/Compras/RequisicaoCompraForm";
import OrdemCompra from "./pages/Compras/OrdemCompra";
import OrdemCompraForm from "./pages/Compras/OrdemCompraForm";
import Cotacoes from "./pages/Compras/Cotacoes";
import CotacaoForm from "./pages/Compras/CotacaoForm";
import CotacaoComparativo from "./pages/Compras/CotacaoComparativo";
import AlcadasConfig from "./pages/Compras/AlcadasConfig";
import HistoricoPrecos from "./pages/Compras/HistoricoPrecos";
import RecebimentoImportar from "./pages/Compras/RecebimentoImportar";
import AjustePrecoRecebimento from "./pages/Compras/AjustePrecoRecebimento";
import ManifestacaoDfe from "./pages/Compras/ManifestacaoDfe";
import Recebimentos from "./pages/Compras/Recebimentos";
import FluxoCaixaCompras from "./pages/Compras/Relatorios/FluxoCaixaCompras";
import SpendAnalytics from "./pages/Compras/Relatorios/SpendAnalytics";
import PerformanceFornecedores from "./pages/Compras/Relatorios/PerformanceFornecedores";
import RelatorioPos from "./pages/Compras/Relatorios/RelatorioPos";
import BudgetCompras from "./pages/Compras/Relatorios/BudgetCompras";
import BudgetVsRealizado from "./pages/Compras/Relatorios/BudgetVsRealizado";
import RelatoriosVendas from "./pages/Relatorios/RelatoriosVendas";
import RelatoriosGerencial from "./pages/Relatorios/RelatoriosGerencial";
import RelatoriosFiscais from "./pages/Relatorios/RelatoriosFiscais";
import RelatoriosFinanceiro from "./pages/Relatorios/RelatoriosFinanceiro";
import MercadoLivre from "./pages/MercadoLivre";
import OpenFinance from "./pages/OpenFinance";
import SmartTef from "./pages/SmartTef";
import GestorHub from "./pages/admin/GestorHub";
import CondutorPage from "./pages/cadastros/Transporte/Condutor";
import ReboquePage from "./pages/cadastros/Transporte/Reboque";
import VeiculoTransportePage from "./pages/cadastros/Transporte/Veiculo";
import CtePage from "./pages/Fiscal/CTe";
import CteOsPage from "./pages/Fiscal/CTeOS";
import MdfePage from "./pages/Fiscal/MDFe";
import AverbacaoPage from "./pages/Fiscal/Averbacao";
import ContadorEntrar from "./pages/Contador/ContadorEntrar";
import ContadorDefinirSenha from "./pages/Contador/ContadorDefinirSenha";
import ContadorLayout from "./pages/Contador/ContadorLayout";
import ContadorClientes from "./pages/Contador/ContadorClientes";
import ContadorCliente from "./pages/Contador/ContadorCliente";

// ── Helper para derivar título a partir do status HTTP ─────────────────────
function httpErrorTitle(error: unknown): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const status: number | undefined = (error as any)?.response?.status;
  if (status === 400 || status === 422) return 'Dados inválidos';
  if (status === 403) return 'Acesso negado';
  if (status === 404) return 'Registro não encontrado';
  if (status != null && status >= 500) return 'Erro no servidor';
  return 'Erro';
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries:   { retry: false, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
  // Falhas de queries (useQuery) são exibidas globalmente via toast.
  // Falhas de mutations têm tratamento local nos próprios hooks.
  queryCache: new QueryCache({
    onError: (error) => {
      toast.error(httpErrorTitle(error), {
        description: error.message || 'Ocorreu um erro inesperado.',
      });
    },
  }),
  // MutationCache captura mutações que não têm onError próprio.
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Só exibe toast global se a mutation não tem handler próprio de erro.
      if (!mutation.options.onError) {
        toast.error(httpErrorTitle(error), {
          description: error.message || 'Ocorreu um erro inesperado.',
        });
      }
    },
  }),
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <PermissoesProvider>
          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/definir-senha" element={<DefinirSenha />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/sem-permissao" element={<SemPermissao />} />
            {/* Portal do Contador: sessão própria, fora do ProtectedRoute e do menu do ERP. */}
            <Route path="/contador/entrar" element={<ContadorEntrar />} />
            <Route path="/contador/definir-senha" element={<ContadorDefinirSenha />} />
            <Route path="/contador" element={<ContadorLayout />}>
              <Route index element={<ContadorClientes />} />
              <Route path="clientes/:id" element={<ContadorCliente />} />
              <Route path="*" element={<Navigate to="/contador" replace />} />
            </Route>
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <SidebarProvider defaultOpen={true}>
                    <div className="flex min-h-screen w-full">
                      <AppSidebar />
                      <div className="flex-1 flex flex-col min-w-0">
                        <TopBar />
                        <main className="flex-1 p-6 bg-background">
                          <Routes>
                            <Route path="/" element={isPontoStandalone ? <Navigate to="/rh/ponto/meu" replace /> : <Index />} />
                            <Route path="/estoque" element={
                              <ProtectedRoute formularioId={FORMULARIOS.AJUSTE_SALDO}><Estoque /></ProtectedRoute>
                            } />
                            <Route path="/pessoas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PESSOAS_EMPRESAS}><Persons /></ProtectedRoute>
                            } />
                            <Route path="/pessoas/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PESSOAS_EMPRESAS}><PersonFormPage /></ProtectedRoute>
                            } />
                            <Route path="/pessoas/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PESSOAS_EMPRESAS}><PersonFormPage /></ProtectedRoute>
                            } />
                            <Route path="/grupos-clientes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GRUPO_PESSOAS}><CustomerGroups /></ProtectedRoute>
                            } />
                            <Route path="/rotas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ROTAS}><Rotas /></ProtectedRoute>
                            } />
                            <Route path="/rotas/montagem" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ROTAS}><RotaMontagem /></ProtectedRoute>
                            } />
                            <Route path="/tabelas-preco" element={
                              <ProtectedRoute formularioId={FORMULARIOS.TABELA_PRECOS}><PriceTables /></ProtectedRoute>
                            } />
                            <Route path="/paises" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PAISES}><Countries /></ProtectedRoute>
                            } />
                            <Route path="/estados" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTADOS}><States /></ProtectedRoute>
                            } />
                            <Route path="/cidades" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CIDADES}><Cities /></ProtectedRoute>
                            } />
                            <Route path="/produtos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTOS}><Produtos /></ProtectedRoute>
                            } />
                            <Route path="/produtos/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTOS}><ProdutoFormPage /></ProtectedRoute>
                            } />
                            <Route path="/produtos/grades-x" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_GRADE_X}><GradeXPage /></ProtectedRoute>
                            } />
                            <Route path="/produtos/grades-y" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_GRADE_Y}><GradeYPage /></ProtectedRoute>
                            } />
                            <Route path="/produtos/opcionais" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_OPCIONAIS}><OpcionaisPage /></ProtectedRoute>
                            } />
                            <Route path="/produtos/grupos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_GRUPOS}><ProductGroups /></ProtectedRoute>
                            } />
                            <Route path="/produtos/subgrupos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_SUBGRUPOS}><ProductSubgroups /></ProtectedRoute>
                            } />
                            <Route path="/produtos/secoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_SECOES}><ProductSections /></ProtectedRoute>
                            } />
                            <Route path="/produtos/subsecoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_SUBSECOES}><ProductSubsections /></ProtectedRoute>
                            } />
                            <Route path="/produtos/marcas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_MARCAS}><ProductBrands /></ProtectedRoute>
                            } />
                            <Route path="/produtos/modelos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_MARCAS}><ProductModels /></ProtectedRoute>
                            } />
                            <Route path="/produtos/garantias" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_MARCAS}><GarantiasCadastro /></ProtectedRoute>
                            } />
                            <Route path="/produtos/unidades" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTO_UNIDADES}><UnidadesProduto /></ProtectedRoute>
                            } />
                            <Route path="/produtos/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PRODUTOS}><ProdutoFormPage /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/notas-fiscais" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFE}><NotasFiscais /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/notas-fiscais/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFE}><NovaNotaFiscal /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/notas-fiscais/:id/editar" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFE}><NovaNotaFiscal /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/notas-fiscais/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFE}><NotaFiscalDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/nfse" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFSE}><NotasServico /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/nfse/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFSE}><EmissaoNfse /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/nfse/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFSE}><DetalheNfse /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/nfce/emitir" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMISSAO_NFCE}><EmissaoNfce /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/sped" element={
                              <ProtectedRoute formularioId={FORMULARIOS.SPED_ICMS_IPI}><Sped /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/impostos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.FISCAL_IMPOSTOS}><Impostos /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/cte" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CTE}><CtePage /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/cte-os" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CTEOS}><CteOsPage /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/mdfe" element={
                              <ProtectedRoute formularioId={FORMULARIOS.MDFE}><MdfePage /></ProtectedRoute>
                            } />
                            <Route path="/fiscal/averbacao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.AVERBACAO}><AverbacaoPage /></ProtectedRoute>
                            } />
                            <Route path="/contabil/apuracoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTABIL_APURACOES}><Apuracoes /></ProtectedRoute>
                            } />
                            <Route path="/contabil/apuracoes/:tipo/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTABIL_APURACOES}><ApuracaoDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/contabil/razao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTABIL_RAZAO}><Razao /></ProtectedRoute>
                            } />
                            <Route path="/contabil/lancamentos/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTABIL_LANCAMENTO}><LancamentoForm /></ProtectedRoute>
                            } />
                            <Route path="/contabil/parametrizacao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTABIL_PARAMETRIZACAO}><ParametrizacaoContabil /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/batida" element={
                              <ProtectedRoute><Batida /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/config" element={
                              <ProtectedRoute><ConfigPonto /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/espelho" element={
                              <ProtectedRoute><EspelhoPonto /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/feriados" element={
                              <ProtectedRoute><Feriados /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/jornadas" element={
                              <ProtectedRoute><Jornadas /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/funcionarios" element={
                              <ProtectedRoute><Funcionarios /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/exportacoes" element={
                              <ProtectedRoute><Exportacoes /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/comprovantes" element={
                              <ProtectedRoute><Comprovantes /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/painel" element={
                              <ProtectedRoute><PainelPonto /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/ajustes" element={
                              <ProtectedRoute><AjustesPonto /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/meu" element={
                              <ProtectedRoute><MeuPonto /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/dispositivos" element={
                              <ProtectedRoute><Dispositivos /></ProtectedRoute>
                            } />
                            <Route path="/rh/ponto/consentimento" element={
                              <ProtectedRoute><ConsentimentoLgpd /></ProtectedRoute>
                            } />
                            <Route path="/contabil/relatorios" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTABIL_RELATORIOS}><RelatoriosContabeis /></ProtectedRoute>
                            } />
                            <Route path="/contabil/central-fiscal" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PLATAFORMA_CONTADOR}><CentralFiscal /></ProtectedRoute>
                            } />
                            <Route path="/contabil/plataforma-contador" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PLATAFORMA_CONTADOR}><PlataformaContador /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/contas-pagar" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_PAGAR}><ContasPagar /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/contas-pagar/gerencial" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_PAGAR}><ContasPagarGerencial /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/contas-receber" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_RECEBER}><ContasReceber /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/contas-receber/gerencial" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_RECEBER}><ContasReceberGerencial /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/faturas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_RECEBER}><Faturas /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/renegociacoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_RECEBER}><Renegociacoes /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/fluxo-caixa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.FLUXO_CAIXA}><FluxoCaixa /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/dashboard-executivo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DASHBOARD_EXECUTIVO}><DashboardExecutivo /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/fluxo-caixa-gerencial" element={
                              <ProtectedRoute formularioId={FORMULARIOS.FLUXO_CAIXA_GERENCIAL}><FluxoCaixaGerencial /></ProtectedRoute>
                            } />
                            <Route path="/config/perfis" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GERENCIAMENTO_ACESSO}><ConfiguracaoPerfil /></ProtectedRoute>
                            } />
                            {/* Cadastros Financeiros */}
                            <Route path="/cadastros/bancos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.BANCOS}><Bancos /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/contas-correntes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_CORRENTES}><ContasCorrentes /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/cartoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CARTOES}><Cartoes /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/formas-pagamento" element={
                              <ProtectedRoute formularioId={FORMULARIOS.FORMAS_PAGAMENTO}><FormasPagamento /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/condicoes-pagamento" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONDICOES_PAGAMENTO}><CondicoesPagamento /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/operacoes-fluxo-caixa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.OPERACOES_FLUXO_CAIXA}><OperacoesFluxoCaixa /></ProtectedRoute>
                            } />
                            {/* Cadastros Contábil */}
                            <Route path="/cadastros/centros-custo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CENTROS_CUSTO}><CentrosCusto /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/grupos-despesa-receita" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GRUPOS_DESPESA_RECEITA}><GruposDespesaReceita /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/contas-despesa-receita" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTAS_DESPESA_RECEITA}><ContasDespesaReceita /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/plano-contas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PLANO_CONTAS}><PlanoDeContas /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/plano-contas-gerencial" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PLANO_CONTAS_GERENCIAL}><PlanoDeContasGerencial /></ProtectedRoute>
                            } />
                            {/* Configurações */}
                            <Route path="/configuracoes/empresa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.EMPRESA_FILIAL_GRUPO}><ConfiguracaoEmpresa /></ProtectedRoute>
                            } />
                            {/* Chaves de API — pessoal, qualquer usuário autenticado */}
                            <Route path="/configuracoes/api-keys" element={
                              <ProtectedRoute><ApiKeys /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/fiscal" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_FISCAL}><ConfiguracoesFiscais /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/nfse" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_NFSE}><ConfiguracaoNfse /></ProtectedRoute>
                            } />
                            {/* RENAVE — estoque de veículos de revenda */}
                            <Route path="/configuracoes/renave" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_RENAVE}><ConfiguracaoRenave /></ProtectedRoute>
                            } />
                            <Route path="/estoque/veiculos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.VEICULOS_ESTOQUE}><VeiculosEstoque /></ProtectedRoute>
                            } />
                            <Route path="/estoque/veiculos/pendencias" element={
                              <ProtectedRoute formularioId={FORMULARIOS.VEICULOS_ESTOQUE}><PendenciasRenave /></ProtectedRoute>
                            } />
                            <Route path="/estoque/veiculos/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.VEICULOS_ESTOQUE}><VeiculoEstoqueDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/importacao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.IMPORTACAO_DADOS}><ImportacaoDados /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/sistema" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_GERAL}><ParametrosSistema /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/dashboard-perfis" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DASHBOARD_CONFIG}><DashboardPerfis /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/whatsapp" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_WHATSAPP}><ConfiguracoesWhatsApp /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/whatsapp-cloud" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_WHATSAPP}><ConfiguracoesWhatsAppCloud /></ProtectedRoute>
                            } />
                            <Route path="/configuracoes/whatsapp-templates" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONFIG_WHATSAPP_TEMPLATES}><WhatsAppTemplates /></ProtectedRoute>
                            } />
                            {/* Cadastros Estoque */}
                            <Route path="/cadastros/locais-estoque" element={
                              <ProtectedRoute formularioId={FORMULARIOS.LOCAIS_ESTOQUE}><LocalEstoque /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/veiculos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.VEICULOS}><Veiculos /></ProtectedRoute>
                            } />
                            {/* Cadastros Transporte — CT-e / MDFe */}
                            <Route path="/cadastros/transporte/veiculos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.VEICULOS_TRANSPORTE}><VeiculoTransportePage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/transporte/condutores" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONDUTORES}><CondutorPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/transporte/reboques" element={
                              <ProtectedRoute formularioId={FORMULARIOS.REBOQUES}><ReboquePage /></ProtectedRoute>
                            } />
                            {/* Cadastros Fiscal */}
                            <Route path="/cadastros/fiscal/cfop" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CFOP}><CfopPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/cst-icms" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CST_ICMS}><CstIcmsPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/natureza-operacao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.NATUREZA_OPERACAO}><NaturezaOperacaoPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/classificacao-fiscal" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CLASSIFICACAO_FISCAL}><ClassificacaoFiscalPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/correlacao-cfop-cst" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CORRELACAO_CFOP_CST}><CorrelacaoCfopCstPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/regra-fiscal" element={
                              <ProtectedRoute formularioId={FORMULARIOS.REGRAS_FISCAIS_NCM}><RegraFiscalPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/cclass-trib" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CCLASS_TRIB}><CClassTribPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/cbenef" element={
                              <ProtectedRoute formularioId={FORMULARIOS.BENEFICIO_FISCAL_CBENEF}><BeneficioFiscalPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/cest" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CEST}><CestPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/monofasicos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.MONOFASICOS}><MonofasicoPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/tributos-uf-destino" element={
                              <ProtectedRoute formularioId={FORMULARIOS.TRIBUTOS_UF_DESTINO}><TributosUfDestinoPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/fcp-partilha" element={
                              <ProtectedRoute formularioId={FORMULARIOS.FCP_PARTILHA}><FcpPartilhaPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/anp" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ANP_COMBUSTIVEIS}><AnpCombustivelPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/monofasico-anp" element={
                              <ProtectedRoute formularioId={FORMULARIOS.MONOFASICO_ANP}><MonofasicosAnpPage /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/fiscal/ncm" element={
                              <ProtectedRoute formularioId={FORMULARIOS.REGRAS_FISCAIS_NCM}><NcmPageComp /></ProtectedRoute>
                            } />
                            {/* Cadastros Usuários */}
                            <Route path="/cadastros/usuarios" element={
                              <ProtectedRoute formularioId={FORMULARIOS.USUARIOS}><Usuarios /></ProtectedRoute>
                            } />
                            <Route path="/cadastros/perfis" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PERFIS_ACESSO}><Perfis /></ProtectedRoute>
                            } />
                            {/* Operacional */}
                            <Route path="/operacional/dav" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DAV}><Dav /></ProtectedRoute>
                            } />
                            <Route path="/operacional/dav/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DAV}><DavForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/dav/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DAV}><DavForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/dav/:id/imprimir-termica" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DAV}><DavImpressaoTermica /></ProtectedRoute>
                            } />
                            <Route path="/operacional/orcamentos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORCAMENTOS}><Orcamentos /></ProtectedRoute>
                            } />
                            <Route path="/operacional/orcamentos/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORCAMENTOS}><OrcamentoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/orcamentos/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORCAMENTOS}><OrcamentoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/waves" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ENTREGAS}><Waves /></ProtectedRoute>
                            } />
                            <Route path="/operacional/waves/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ENTREGAS}><WaveDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/operacional/entregas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ENTREGAS}><Entregas /></ProtectedRoute>
                            } />
                            <Route path="/operacional/os" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORDEM_SERVICO}><OrdemServico /></ProtectedRoute>
                            } />
                            <Route path="/operacional/os/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORDEM_SERVICO}><OrdemServicoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/os/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORDEM_SERVICO}><OrdemServicoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/status-os" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ORDEM_SERVICO}><StatusOs /></ProtectedRoute>
                            } />
                            <Route path="/operacional/condicional" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONDICIONAL}><Condicional /></ProtectedRoute>
                            } />
                            <Route path="/operacional/condicional/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONDICIONAL}><CondicionalForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/condicional/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONDICIONAL}><CondicionalForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM}><Crm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM}><CrmDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM}><CrmDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm-pipeline" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM_PIPELINE}><CrmPipeline /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm-dashboard" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM_DASHBOARD}><CrmDashboardPage /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm-relatorios" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM_RELATORIOS}><CrmRelatoriosPage /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm-visao360" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM}><Visao360 /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm-atividades" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM}><Atividades /></ProtectedRoute>
                            } />
                            <Route path="/operacional/crm-campanhas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CRM}><Campanhas /></ProtectedRoute>
                            } />
                            <Route path="/operacional/cargas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CARGAS}><Cargas /></ProtectedRoute>
                            } />
                            <Route path="/operacional/cargas/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CARGAS}><CargaForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/cargas/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CARGAS}><CargaForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/projetos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PROJETOS}><Projetos /></ProtectedRoute>
                            } />
                            <Route path="/operacional/projetos/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PROJETOS}><ProjetoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/projetos/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PROJETOS}><ProjetoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/apontamento-horas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PROJETO_APONTAMENTO}><ApontamentoHoras /></ProtectedRoute>
                            } />
                            <Route path="/operacional/aprovacao-timesheet" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PROJETO_APROVACAO}><AprovacaoTimesheet /></ProtectedRoute>
                            } />
                            <Route path="/operacional/pcp" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PCP}><PcpOrdens /></ProtectedRoute>
                            } />
                            <Route path="/operacional/pcp/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PCP}><PcpOrdemForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/pcp/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PCP}><PcpOrdemForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/fichas-tecnicas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.FICHA_TECNICA}><FichasTecnicas /></ProtectedRoute>
                            } />
                            <Route path="/operacional/etapas-producao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ETAPAS_PRODUCAO}><EtapasProducao /></ProtectedRoute>
                            } />
                            <Route path="/operacional/planejamento-mrp" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PLANEJAMENTO_MRP}><PlanejamentoMrp /></ProtectedRoute>
                            } />
                            <Route path="/operacional/liberacao-desconto" element={
                              <ProtectedRoute formularioId={FORMULARIOS.LIBERACAO_DESCONTO}><LiberacaoDesconto /></ProtectedRoute>
                            } />
                            <Route path="/operacional/requisicoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.REQUISICOES_INTERNAS}><Requisicao /></ProtectedRoute>
                            } />
                            <Route path="/operacional/requisicoes/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.REQUISICOES_INTERNAS}><RequisicaoForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/requisicoes/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.REQUISICOES_INTERNAS}><RequisicaoForm /></ProtectedRoute>
                            } />
                            {/* PDV — Frente de Caixa (T2) */}
                            <Route path="/pdv/frente-caixa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PDV_FRENTE_CAIXA}><FrenteCaixa /></ProtectedRoute>
                            } />
                            <Route path="/pdv/historico-estornos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PDV_FRENTE_CAIXA}><HistoricoEstornos /></ProtectedRoute>
                            } />
                            <Route path="/pdv/conciliacao-caixa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PDV_CONCILIACAO_CAIXA}><ConciliacaoCaixa /></ProtectedRoute>
                            } />
                            <Route path="/pdv/sincronizacao-offline" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PDV_FRENTE_CAIXA}><SincronizacaoOffline /></ProtectedRoute>
                            } />
                            {/* Estoque — Módulo Gestão */}
                            <Route path="/estoque/posicao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_POSICAO}><PosicaoEstoque /></ProtectedRoute>
                            } />
                            <Route path="/estoque/movimentacoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_MOVIMENTACOES}><MovimentacaoEstoque /></ProtectedRoute>
                            } />
                            <Route path="/estoque/movimentacoes/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_MOVIMENTACOES}><MovimentacaoForm /></ProtectedRoute>
                            } />
                            <Route path="/estoque/inventario" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_INVENTARIO}><InventarioEstoque /></ProtectedRoute>
                            } />
                            <Route path="/estoque/inventario/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_INVENTARIO}><InventarioForm /></ProtectedRoute>
                            } />
                            <Route path="/estoque/inventario/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_INVENTARIO}><InventarioForm /></ProtectedRoute>
                            } />
                            <Route path="/estoque/reposicao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_REPOSICAO}><NecessidadeReposicao /></ProtectedRoute>
                            } />
                            <Route path="/estoque/relatorios" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_RELATORIOS}><RelatoriosEstoque /></ProtectedRoute>
                            } />
                            <Route path="/estoque/lotes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_LOTES}><GestaoLotes /></ProtectedRoute>
                            } />
                            <Route path="/estoque/historico" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_HISTORICO}><HistoricoMovProduto /></ProtectedRoute>
                            } />
                            <Route path="/estoque/movimentacoes/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_MOVIMENTACOES}><MovimentacaoDetalhe /></ProtectedRoute>
                            } />
                            <Route path="/estoque/etiquetas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_ETIQUETAS}><Etiquetas /></ProtectedRoute>
                            } />
                            {/* WMS — Transferência entre depósitos + Cycle Counting */}
                            <Route path="/estoque/transferencias" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_TRANSFERENCIAS}><TransferenciasEstoque /></ProtectedRoute>
                            } />
                            <Route path="/estoque/transferencias/regras" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_REGRAS_TRANSFERENCIA}><RegrasAprovacaoTransferencia /></ProtectedRoute>
                            } />
                            <Route path="/estoque/ciclos-contagem" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_CICLOS_CONTAGEM}><CiclosContagem /></ProtectedRoute>
                            } />
                            <Route path="/estoque/contagens-ciclo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_CONTAGEM_CICLO}><ContagensCiclo /></ProtectedRoute>
                            } />
                            <Route path="/estoque/ajustes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ESTOQUE_AJUSTES}><AjustesEstoque /></ProtectedRoute>
                            } />
                            {/* Caixa */}
                            <Route path="/financeiro/caixa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CAIXAS}><Caixa /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/controle-caixas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONTROLE_CAIXAS}><ControleCaixas /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/relatorios" element={
                              <ProtectedRoute formularioId={FORMULARIOS.RELATORIOS_FINANCEIROS}><RelatoriosFinanceiros /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/conciliacao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONCILIACAO_BANCARIA}><ConciliacaoBancaria /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/conciliacao-ofx" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONCILIACAO_OFX}><ConciliacaoOfx /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/integracao-bancaria" element={
                              <ProtectedRoute formularioId={FORMULARIOS.CONCILIACAO_BANCARIA}><IntegracaoBancaria /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/gerenciamento-cartao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GERENCIAMENTO_CARTAO}><GerenciamentoCartao /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/pagamento-lote" element={
                              <ProtectedRoute formularioId={FORMULARIOS.PAGAMENTO_LOTE}><PagamentoLote /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/ativos-fixos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.ATIVOS_FIXOS}><AtivosFixos /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/boletos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.BOLETOS}><GestaoBoletos /></ProtectedRoute>
                            } />
                            <Route path="/financeiro/transferencias" element={
                              <ProtectedRoute formularioId={FORMULARIOS.TRANSFERENCIAS}><Transferencias /></ProtectedRoute>
                            } />
                            {/* Garantias */}
                            <Route path="/operacional/garantias" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GARANTIAS}><Garantias /></ProtectedRoute>
                            } />
                            <Route path="/operacional/garantias/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GARANTIAS}><GarantiaForm /></ProtectedRoute>
                            } />
                            <Route path="/operacional/garantias/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.GARANTIAS}><GarantiaForm /></ProtectedRoute>
                            } />
                            {/* Receitas Médicas (SNGPC) */}
                            <Route path="/operacional/sngpc-receitas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DAV}><ReceitasSngpc /></ProtectedRoute>
                            } />
                            {/* Transmissões SNGPC */}
                            <Route path="/operacional/sngpc-transmissoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.DAV}><TransmissoesSngpc /></ProtectedRoute>
                            } />
                            {/* Compras (P2P) */}
                            <Route path="/compras/fornecedores" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_FORNECEDORES}><Fornecedores /></ProtectedRoute>
                            } />
                            <Route path="/compras/fornecedores/novo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_FORNECEDORES}><FornecedorForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/fornecedores/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_FORNECEDORES}><FornecedorForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/requisicoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REQUISICOES}><RequisicaoCompra /></ProtectedRoute>
                            } />
                            <Route path="/compras/requisicoes/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REQUISICOES}><RequisicaoCompraForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/requisicoes/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REQUISICOES}><RequisicaoCompraForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/ordens" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_ORDENS}><OrdemCompra /></ProtectedRoute>
                            } />
                            <Route path="/compras/ordens/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_ORDENS}><OrdemCompraForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/ordens/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_ORDENS}><OrdemCompraForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/cotacoes" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_COTACOES}><Cotacoes /></ProtectedRoute>
                            } />
                            <Route path="/compras/cotacoes/nova" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_COTACOES}><CotacaoForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/cotacoes/:id" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_COTACOES}><CotacaoForm /></ProtectedRoute>
                            } />
                            <Route path="/compras/cotacoes/:id/comparativo" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_COTACOES}><CotacaoComparativo /></ProtectedRoute>
                            } />
                            <Route path="/compras/alcadas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_ALCADAS}><AlcadasConfig /></ProtectedRoute>
                            } />
                            <Route path="/compras/historico-precos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_HISTORICO_PRECOS}><HistoricoPrecos /></ProtectedRoute>
                            } />
                            <Route path="/compras/recebimentos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_RECEBIMENTOS}><Recebimentos /></ProtectedRoute>
                            } />
                            <Route path="/compras/recebimentos/importar" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_IMPORTAR_NFE}><RecebimentoImportar /></ProtectedRoute>
                            } />
                            <Route path="/compras/recebimentos/:id/ajuste-preco" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_AJUSTE_PRECO}><AjustePrecoRecebimento /></ProtectedRoute>
                            } />
                            <Route path="/compras/recebimentos/:id/manifestacao" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_MANIFESTACAO_DFE}><ManifestacaoDfe /></ProtectedRoute>
                            } />
                            <Route path="/compras/relatorios/fluxo-caixa" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REL_FLUXO_CAIXA}><FluxoCaixaCompras /></ProtectedRoute>
                            } />
                            <Route path="/compras/relatorios/spend-analytics" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REL_SPEND}><SpendAnalytics /></ProtectedRoute>
                            } />
                            <Route path="/compras/relatorios/performance-fornecedores" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REL_PERFORMANCE}><PerformanceFornecedores /></ProtectedRoute>
                            } />
                            <Route path="/compras/relatorios/pedidos" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REL_PEDIDOS}><RelatorioPos /></ProtectedRoute>
                            } />
                            <Route path="/compras/budget" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_BUDGET}><BudgetCompras /></ProtectedRoute>
                            } />
                            <Route path="/compras/relatorios/budget-vs-realizado" element={
                              <ProtectedRoute formularioId={FORMULARIOS.COMPRAS_REL_BUDGET_VS_REAL}><BudgetVsRealizado /></ProtectedRoute>
                            } />
                            {/* Relatórios */}
                            <Route path="/relatorios/vendas" element={
                              <ProtectedRoute formularioId={FORMULARIOS.RELATORIOS_VENDAS}><RelatoriosVendas /></ProtectedRoute>
                            } />
                            <Route path="/relatorios/gerencial" element={
                              <ProtectedRoute formularioId={FORMULARIOS.RELATORIOS_GERENCIAIS}><RelatoriosGerencial /></ProtectedRoute>
                            } />
                            <Route path="/relatorios/fiscais" element={
                              <ProtectedRoute formularioId={FORMULARIOS.RELATORIOS_FISCAIS}><RelatoriosFiscais /></ProtectedRoute>
                            } />
                            <Route path="/relatorios/financeiro" element={
                              <ProtectedRoute formularioId={FORMULARIOS.RELATORIOS_FINANCEIROS}><RelatoriosFinanceiro /></ProtectedRoute>
                            } />
                            {/* Integrações */}
                            <Route path="/integracao/mercadolivre" element={
                              <ProtectedRoute formularioId={FORMULARIOS.INTEGRACAO_MERCADOLIVRE}><MercadoLivre /></ProtectedRoute>
                            } />
                            <Route path="/integracao/open-finance" element={
                              <ProtectedRoute formularioId={FORMULARIOS.INTEGRACAO_OPEN_FINANCE}><OpenFinance /></ProtectedRoute>
                            } />
                            <Route path="/integracao/smart-tef" element={
                              <ProtectedRoute formularioId={FORMULARIOS.INTEGRACAO_SMART_TEF}><SmartTef /></ProtectedRoute>
                            } />
                            {/* Mentor IA */}
                            <Route path="/mentor" element={
                              <ProtectedRoute formularioId={FORMULARIOS.MENTOR_IA}><MentorIA /></ProtectedRoute>
                            } />
                            {/* Mentor IA — Operacional (agentes com gate) */}
                            <Route path="/mentor/operacional" element={
                              <ProtectedRoute formularioId={FORMULARIOS.MENTOR_IA}><MentorOperacional /></ProtectedRoute>
                            } />
                            {/* Admin Global — Gestor Hub */}
                            <Route path="/admin/hub" element={<GestorHub />} />
                            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                            <Route path="*" element={<NotFound />} />
                          </Routes>
                        </main>
                      </div>
                    </div>
                  </SidebarProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
          </PermissoesProvider>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
